<template>
	<inertia-head title="Dashboard" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Delivery Freebook</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Delivery Freebook Management</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		
		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<div class="row">
					<div class="col-md-4">
						<div class="input-group">
							<div class="input-group-prepend"><span class="input-group-text">Filter By Region</span></div>
							<select v-model="region" class="form-select">
								<option value="ALL">ALL</option>
			                    <option value="Luzon">Luzon</option>
			                    <option value="NCR">NCR</option>
			                    <option value="Visayas">Visayas</option>
			                    <option value="Mindanao">Mindanao</option>
							</select>
						</div>
					</div>
					<div class="col-md-4">
						<div class="input-group">
							<div class="input-group-prepend"><span class="input-group-text">Filter By Delivery Status</span></div>
							<select v-model="delivery_status" class="form-select">
								<option value="ALL">ALL</option>
			                    <option value="Delivered">Delivered</option>
			                    <option value="Shipped">Shipped</option>
			                    <option value="Pending">Pending</option>
							</select>
						</div>
					</div>
					<div class="col-md-4">
						<div class="input-group">
							<div class="input-group-prepend"><span class="input-group-text">Filter By Payment Status</span></div>
							<select v-model="status" class="form-select">
								<option value="ALL">ALL</option>
			                    <option value="S">Completed</option>
			                    <option value="P">Pending</option>
			                    <option value="F">Failed</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title">Filter By Payment Completed Date</div>
			</div>
			<div class="block-content block-content-full">
				<div class="row">
					<div class="col-md-5">
						<div class="form-floating mb-4">
							<flat-pickr
								v-model="date_start"
								:config="{
									// enableTime: true,
									altInput: true,
									altFormat: 'M j, Y',
									dateFormat: 'Y-m-d',
								}"
								class="form-control"
							/>
							<label class="form-label" for="date_start">FROM</label>
						</div>
					</div>
					<div class="col-md-5">
						<div class="form-floating mb-4">
							<flat-pickr
								v-model="date_end"
								:config="{
									// enableTime: true,
									altInput: true,
									altFormat: 'M j, Y',
									dateFormat: 'Y-m-d',
								}"
								class="form-control"
							/>
							<label class="form-label" for="date_end">TO</label>
						</div>
					</div>
					<div class="col-md-2">
						<div class="form-floating mb-4">
							<button type="button" @click="searchByDateCompleted" id="btnDateRange" name="btnDateRange" class="btn btn-info"><i class="fa fa-search me-1"></i>Search</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-options">
					<label class="fw-bold">Payment Total</label>
					<div>
						<span class="badge bg-success me-1">Completed: {{totals.payment_total_completed}}</span>
						<span class="badge bg-warning">Pending: {{totals.payment_total_pending}}</span>
					</div>
				</div>
				<div class="block-options">
					<label class="fw-bold">Shipping Total</label>
					<div>
						<span class="badge bg-success me-1">Delivered: {{totals.shipping_total_delivered}}</span>
						<span class="badge bg-info me-1">Shipped: {{totals.shipping_total_shipped}}</span>
						<span class="badge bg-warning">Pending: {{totals.shipping_total_pending}}</span>
					</div>
				</div>
			</div>
			<div class="block-header">
				<div class="block-title me-5">
					<form @submit.prevent="fetchDeliveryFreebooks">
						<div class="input-group">
							<input type="text" v-model="search" id="search" name="search" class="form-control" placeholder="Search"/>
							<div class="input-group-prepend">
								<span class="input-group-btn">
									<button type="submit" id="btnSearch" name="btnSearch" class="btn btn-info"><i class="fa fa-search me-1"></i>Search</button>
								</span>
							</div>
						</div>
					</form>
				</div>
				<div class="block-options">
					<button @click="exportToCSV" type="button" class="btn btn-success"><i class="fa fa-download me-1"></i>Export to CSV</button>
				</div>
			</div>
			<div class="block-content block-content-full">
				<!-- Pagination -->
				<pagination v-if="deliveryFreebooks.data.length > 0" :collections="deliveryFreebooks"/>
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>uuid</th>
								<th>refno</th>
								<th>Customer</th>
								<th>Address</th>
								<th>Amount</th>
								<th>Payment Status</th>
								<th>Delivery Status</th>
								<th>Settled</th>
								<th>Created</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(row, c_index) in deliveryFreebooks.data" class="fs-sm">
								<td>
									{{row.delivery_freebook_uuid}}
									<div><button @click="viewDeliveryFreebookContentModal(c_index)" type="button" class="btn btn-sm btn-alt-info" title="Update the details"><i class="fa fa-pencil-alt"></i></button></div>
								</td>
								<td>{{row.refno}}</td>
								<td>
									{{row.fname}} {{row.lname}}
									<div>
										{{row.email}}
										<div><sub>{{row.mobile}}</sub></div>
										<div v-if="row.source!=null"><sub class="badge bg-warning">{{row.source}}</sub></div>
									</div>
								</td>
								<td>
									{{row.address}}
									<div class="text-gray-dark">{{row.barangay}}, {{row.city}}, {{row.province}}, {{row.country}}</div>
								</td>
								<td>
									<sub><span class="badge bg-success">{{row.mop}}</span></sub>
									<div>{{row.amount}}</div>
								</td>
								<td>
									<span :class="{'text-success':row.status=='S','text-warning':row.status=='P','text-danger':row.status=='F'}">
										<span v-if="row.status=='S'">Completed</span>
										<span v-if="row.status=='P'">Pending</span>
										<span v-if="row.status=='F'">Failed</span>
									</span>
								</td>
								<td>
									<span :class="{'text-success':row.delivery_status=='Delivered','text-warning':row.delivery_status=='Shipped','text-danger':row.delivery_status=='Pending'}">
										{{row.delivery_status}}
									</span>
									<div v-if="row.delivery_status!='Pending'">
										{{row.courier}}
										<div>{{row.tracking_link}}</div>
									</div>
								</td>
								<td>{{row.settled_date}}</td>
								<td>{{row.created_at}}</td>
							</tr>
							<tr v-if="deliveryFreebooks.data.length <= 0">
								<td colspan="9" class="mb-0 fw-semibold text-center p-5">NO DELIVERY FREEBOOKS FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="deliveryFreebooks.data.length > 0" :collections="deliveryFreebooks"/>
			</div>
		</div>
		<update-delivery-freebook-modal ref="updateDeliveryFreebookModal" :content="selectedDeliveryFreebookContent"/>
	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import UpdateDeliveryFreebookModal from '../../Components/Admin/UpdateDeliveryFreebookModal'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		totals				: Object,
		deliveryFreebooks	: Object,
		exportData			: String,
		region 				: String,
		status 				: String,
		delivery_status 	: String,
		date_start 			: String,
		date_end 			: String,
		search 				: String,
		errors 				: Object,
		api_response 		: Object
	},
	components:{UpdateDeliveryFreebookModal},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const region 			= ref(props.region);
		const status 			= ref(props.status);
		const delivery_status 	= ref(props.delivery_status);
		const date_start 		= ref(props.date_start);
		const date_end 			= ref(props.date_end);

		const search = ref(props.search);

		const action = ref('add');

		const toast = createToaster();

		const selectedDeliveryFreebookContent = reactive({});

		const updateDeliveryFreebookModal = ref(null);

		const viewDeliveryFreebookContentModal = (_index)=>{
			
			selectedDeliveryFreebookContent.delivery_freebook_uuid 	= props.deliveryFreebooks.data[_index].delivery_freebook_uuid;
			selectedDeliveryFreebookContent.fname 					= props.deliveryFreebooks.data[_index].fname;
			selectedDeliveryFreebookContent.lname 					= props.deliveryFreebooks.data[_index].lname;
			selectedDeliveryFreebookContent.email 					= props.deliveryFreebooks.data[_index].email;
			selectedDeliveryFreebookContent.mobile 					= props.deliveryFreebooks.data[_index].mobile;
			selectedDeliveryFreebookContent.mop 					= props.deliveryFreebooks.data[_index].mop;
			selectedDeliveryFreebookContent.amount 					= props.deliveryFreebooks.data[_index].amount;
			selectedDeliveryFreebookContent.status 					= props.deliveryFreebooks.data[_index].status;
			selectedDeliveryFreebookContent.delivery_status 		= props.deliveryFreebooks.data[_index].delivery_status;
			selectedDeliveryFreebookContent.delivery_remark 		= props.deliveryFreebooks.data[_index].delivery_remark;
			selectedDeliveryFreebookContent.courier 				= props.deliveryFreebooks.data[_index].courier;
			selectedDeliveryFreebookContent.tracking_link 			= props.deliveryFreebooks.data[_index].tracking_link;
			selectedDeliveryFreebookContent.source 					= props.deliveryFreebooks.data[_index].source;

			updateDeliveryFreebookModal.value.setDeliveryFreebookContent(selectedDeliveryFreebookContent);

			updateDeliveryFreebookModal.value.toggleModal();

		}

		const fetchDeliveryFreebooks = ()=>{

			Inertia.get(
						'/admin/delivery/freebooks', {region:region.value,status:status.value,delivery_status:delivery_status.value,search:search.value},
						{
							// replace: true,
							preserveState: false,
							preserveScroll: true,
							only: ['totals','deliveryFreebooks', 'region', 'status', 'delivery_status', 'search','date_start','date_end']
						}
					)
		}

		const searchByDateCompleted = ()=>{

			var param = {region:region.value,status:status.value,delivery_status:delivery_status.value,date_start:date_start.value,date_end:date_end.value}

			Inertia.get(
				'/admin/delivery/freebooks', param,
				{
					// replace: true,
					preserveState: true,
					preserveScroll: true,
					only: ['totals','deliveryFreebooks', 'region', 'status', 'delivery_status', 'search','date_start','date_end']
				}
			)

		}

		const exportToCSV = ()=>{

			Inertia.get(
						'/admin/delivery/freebooks', {region:region.value,status:status.value,delivery_status:delivery_status.value,search:search.value,date_start:date_start.value,date_end:date_end.value,export:'yes'},
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['totals','deliveryFreebooks','exportData', 'region', 'status', 'delivery_status', 'search','date_start','date_end'],
							onSuccess:()=>{
								let d 			= new Date();
							   	let file_name 	= "delivery_freebooks_list_report_"+d.getFullYear()+d.getMonth()+d.getDate();
							   	let header 		= "application/vnd.ms-excel";
							   	let data 		= props.exportData;
							   	let blob 		= new Blob([data], {header});
							   	let url 		= window.URL.createObjectURL(blob);
							   	let link 		= document.createElement("a");

								file_name = file_name+".xls";
								
							    link.download = file_name;
							    link.href = url;
							    link.click();

								window.URL.revokeObjectURL(url);
							}
						}
					)
		}

		watch([region,status,delivery_status], ([region,status,delivery_status],[old_region,old_status,old_delivery_status]) => {
			
			var param = {region:region,status:status,delivery_status:delivery_status,search:search.value}

			if(region!=old_region)
			{
				Inertia.get(
						'/admin/delivery/freebooks', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['totals','deliveryFreebooks', 'region', 'status', 'delivery_status', 'search','date_start','date_end']
						}
					)
			}

			if(status!=old_status)
			{
				Inertia.get(
						'/admin/delivery/freebooks', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['totals','deliveryFreebooks', 'region', 'status', 'delivery_status', 'search','date_start','date_end']
						}
					)
			}

			if(delivery_status!=old_delivery_status)
			{
				Inertia.get(
						'/admin/delivery/freebooks', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['totals','deliveryFreebooks', 'region', 'status', 'delivery_status', 'search','date_start','date_end']
						}
					)
			}
		})

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='add' ? 'generated' : 'updated';

				if(value.result=="success")
				{
					toast.show(value.data, { type: value.result});
				}else
				{
					toast.show(value.data, { type: "error"});
				}
			}
		})

		return{
			region,
			status,
			delivery_status,
			date_start,
			date_end,
			search,
			action,
			toast,
			viewDeliveryFreebookContentModal,
			selectedDeliveryFreebookContent,
			updateDeliveryFreebookModal,
			fetchDeliveryFreebooks,
			searchByDateCompleted,
			exportToCSV
		}
	},
}
</script>
